



















































import Vue from "vue";
import BillingHistory from "../components/Billing/BillingHistory.vue";
import SubscriptionInfo from "../components/Billing/SubscriptionInfo.vue";
import PaymentMethod from "../components/Billing/PaymentMethod.vue";
import OrganizationSelect from "../components/OrganizationSelect.vue";
import { bus } from "../main";
import { getBillingInfoByOrgId, getUpcomingInvoice } from "@/helpers/api";
import { mapGetters } from "vuex";
import GetterTypes from "@/store/GetterTypes";
import { PermissionKeys } from "@/types";

interface State {
  billingInfo: any;
  invoice: any;
  trialText: string | null;
}

export default Vue.extend({
  name: "Billing",
  components: {
    BillingHistory,
    SubscriptionInfo,
    PaymentMethod,
    OrganizationSelect
  },
  data(): State {
    return {
      billingInfo: null,
      invoice: null,
      trialText: null
    };
  },
  methods: {
    getCurrentOrg() {
      return this.$route.query.orgId;
    },
    async updatePage() {
      await this.getBillingInfo();
    },
    async getBillingInfo() {
      bus.$emit("loadingOn", "Loading...");

      this.billingInfo = await getBillingInfoByOrgId(this.selectedOrg.id);
      console.log(this.billingInfo);
      this.invoice = await getUpcomingInvoice(this.selectedOrg.id);

      this.trialText = this.showTrialEndIfActive();
      bus.$emit("loadingOff");
    },
    getFormattedDate(unix: number) {
      const ms = unix * 1000;
      const date = new Date(ms);
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      return `${
        months[date.getMonth()]
      } ${date.getDate()}, ${date.getFullYear()}`;
    },
    showTrialEndIfActive(): string | null {
      let text: string | null = null;
      this.billingInfo?.subscriptions?.forEach((sub: any) => {
        if (sub.trialEnd && sub.status === "trialing") {
          text = !text
            ? `Your free period ends on ${this.getFormattedDate(sub.trialEnd)}`
            : `${text}, and on ${this.getFormattedDate(sub.trialEnd)}`;
          sub.items.data.forEach((item: any, idx: number) => {
            if (item.plan?.nickname) {
              const separator = idx > 0 ? ", " : " for ";
              text = text + separator + item.plan.nickname;
            }
          });
        }
      });
      return text;
    }
  },
  computed: {
    PermissionKeys() {
      return PermissionKeys;
    },
    failedInvoices(): any {
      return this.billingInfo &&
        this.billingInfo.invoices &&
        //If subcriptionId and subscriptionDeadline, a payment has failed
        this.billingInfo.organization.subscriptionId &&
        this.billingInfo.organization.subscriptionDeadline
        ? this.billingInfo.invoices.reduce((acc: any, invoice: any) => {
            if (!invoice.paid && invoice.status === "open") {
              acc.push({
                id: invoice.id,
                total: invoice.total
              });
            }
            return acc;
          }, [])
        : null;
    },
    ...mapGetters({
      user: GetterTypes.GET_USER,
      selectedOrg: GetterTypes.GET_ORGANIZATION,
      hasPermission: GetterTypes.GET_COACH_HAS_PERMISSION
    })
  }
});
